import { Controller } from "react-hook-form";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { getReactHookFormNestedError } from "../../../../utils/errors";
import { INPUT_COLOR_BORDER } from "../../../../utils/colors";

const TimezoneSelectField = ({
  control,
  errors = {},
  name = "timezone",
  label = "",
  options = [],
  disabled = false,
}) => {
  const error = getReactHookFormNestedError(errors, name);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        const value =
          options.find((option) => option.value === field.value) || null;

        return (
          <>
            <Autocomplete
              id={name}
              options={options}
              disableClearable
              size="medium"
              hasLabel={Boolean(label)}
              sx={{ my: 0.75 }}
              getOptionLabel={(option) => option.label || ""}
              isOptionEqualToValue={(option, selectedOption) =>
                option.value === selectedOption.value
              }
              value={value}
              onChange={(_, newValue) => {
                const nextTimezone = newValue ? newValue.value : null;
                field.onChange(nextTimezone);
              }}
              disabled={disabled}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  hiddenLabel={!label}
                  error={!!error}
                  variant="filled"
                  size="medium"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "off",
                  }}
                  sx={{
                    backgroundColor: "fields.background",
                    border: `1px solid ${INPUT_COLOR_BORDER}`,
                    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                  }}
                />
              )}
            />
            {error?.message ? (
              <Typography variant="caption" color="error.main">
                {error.message}
              </Typography>
            ) : null}
          </>
        );
      }}
    />
  );
};

export default TimezoneSelectField;
